import { ReactNode } from 'react'
import { Button } from './Button'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  cta?: string
  onCta?: () => void
}

export function EmptyState({ icon, title, description, cta, onCta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center px-6">
      {icon && (
        <div className="flex items-center justify-center text-ink-3 mb-4">
          {icon}
        </div>
      )}
      <p className="text-ink font-medium" style={{ fontSize: 16 }}>{title}</p>
      {description && (
        <p
          className="text-ink-2 max-w-[280px] leading-relaxed whitespace-pre-wrap mt-1.5"
          style={{ fontSize: 14 }}
        >
          {description}
        </p>
      )}
      {cta && onCta && (
        <Button variant="accent" onClick={onCta} className="mt-5">
          {cta}
        </Button>
      )}
    </div>
  )
}

// legacy shim
interface EmptyProps {
  text: string
}

export function Empty({ text }: EmptyProps) {
  return (
    <div className="flex items-center justify-center py-16 text-sm text-ink-2">
      {text}
    </div>
  )
}
